import { render } from "./LogisticTableMonitor.vue?vue&type=template&id=a642eb06"
import script from "./LogisticTableMonitor.vue?vue&type=script&lang=js"
export * from "./LogisticTableMonitor.vue?vue&type=script&lang=js"

import "./LogisticTableMonitor.vue?vue&type=style&index=0&id=a642eb06&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__